import type { ReactNode } from "react";

type FeedbackProps = { children: ReactNode; "aria-label"?: string };

/** Inline status line for loading / informational text. */
export const Feedback = ({ children, role = "status", ...attributes }: FeedbackProps & { role?: "status" | "presentation" }) => (
  <p className="feedback" role={role} {...(role === "presentation" ? {} : attributes)}>
    {children}
  </p>
);

export const ErrorText = ({ children, role = "alert", ...attributes }: FeedbackProps & { role?: "alert" | "presentation" }) => (
  <p className="feedback feedback--error" role={role} {...(role === "presentation" ? {} : attributes)}>
    {children}
  </p>
);

type EmptyStateProps = {
  title: string;
  children?: ReactNode;
  role?: "status" | "alert";
  "aria-label"?: string;
};

/** Empty state that teaches the interface rather than saying "nothing here". */
export const EmptyState = ({ title, children, role = "status", ...attributes }: EmptyStateProps) => (
  <div className="empty-state" role={role} {...attributes}>
    <div className="empty-state__title">{title}</div>
    {children && <div className="t-body-sm">{children}</div>}
  </div>
);

/** Skeleton placeholder rows for a list that is loading. */
export const SkeletonList = ({ rows = 3 }: { rows?: number }) => (
  <div className="stack" aria-busy="true" aria-live="polite">
    {Array.from({ length: rows }, (_, i) => (
      // Fixed-length skeleton; index keys are stable and the list never reorders.
      <div key={i} className="skeleton" />
    ))}
  </div>
);
